export default {
  data() {
    return {
      notifications: [
        {
          title: 'Confirmation message',
          slug: 'appointment_confirmation_message',
          description: 'A confirmation message sent to the client when you create a new appointment'
        },
        {
          title: 'Reminder',
          slug: 'appointment_reminder',
          description: 'A reminder sent to the client 1 day before the appointment'
        }
        // {
        //   title: 'Practitioner notification',
        //   slug: 'inform_practioner_new_appointment',
        //   description: 'A notification sent to the practitioner when a new appointment is created'
        // }
        // {
        //   title: 'Reschedule notification',
        //   slug: 'notify_client_reschedule'
        // },
        // {
        //   title: 'Cancellation notification',
        //   slug: 'notify_client_cancellation'
        // }
      ]
    }
  }
}